/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Represents the processing status of a draft in the staging area.
 * An object whose staging status is not @see {@link Synqo.Cloud.Model.Shared.Staging.EnumStagingStatus.Imported} is excluded from most backend processes,
 * until a person triggers or rejects the import.
 */
export enum EnumStagingStatus {
    /**
     * Newly created staged draft that hasn't been processed
     */
    New = 0,
    /**
     * Staged draft has been reviewed/seen by the system
     */
    Seen = 1,
    /**
     * Staged draft has been rejected
     */
    Rejected = 2,
    /**
     * Staged draft has been successfully imported into the target system
     */
    Imported = 3,
}
